import * as React from 'react';
import { useSelector } from 'react-redux';

import { OffersContainer } from './OffersContainer';
import { selectOffers, selectOffersStatus } from '../../selectors/offers';
import { ERequestStatus } from '../../services/requestStatus';

export const ConditionalOffersContainer: React.FC = () => {
  const status = useSelector(selectOffersStatus);
  const offers = useSelector(selectOffers);

  if (status !== ERequestStatus.Loading && offers.length === 0) {
    return null;
  }

  return <OffersContainer />;
};

ConditionalOffersContainer.displayName = 'ConditionalOffersContainer';
